export default "__VITE_ASSET__zsTlIxXB__"